"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var defaultProps = {
  className: null,
  height: '100%',
  width: '100%',
  onClick: function onClick() {},
  onHover: function onHover() {}
};

/** 
* @param {{
*  className?: string;
*  fill?: React.CSSProperties['fill'] | string | CallableFunction;
*  height?: string|number;
*  width?: string|number;
*  onClick?: CallableFunction;
*  onHover?: CallableFunction;
*  [key: string]: any;
* }} props - Component props
*/
function MailCircle(_ref) {
  var className = _ref.className,
    fill = _ref.fill,
    height = _ref.height,
    width = _ref.width,
    onClick = _ref.onClick,
    onHover = _ref.onHover;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onClick: onClick,
    onMouseEnter: onHover,
    onMouseLeave: onHover,
    role: "none"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Mail"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32,0A32,32,0,1,0,64,32,32,32,0,0,0,32,0ZM50,40.44a2.26,2.26,0,0,1-2.25,2.25H16.25A2.26,2.26,0,0,1,14,40.44V27.72l16,8.52a4.4,4.4,0,0,0,4,0l16-8.4Zm0-15.18-17.09,9a2.21,2.21,0,0,1-1.82,0L14,25.13V23.56a2.26,2.26,0,0,1,2.25-2.25h31.5A2.26,2.26,0,0,1,50,23.56Z",
    style: {
      fill: fill
    }
  })));
}
MailCircle.defaultProps = defaultProps;
var _default = exports.default = MailCircle;